import { useTranslations } from "next-intl";

export default function ProductsEmptyState() {
  const t = useTranslations("SearchNav");

  return (
    <div className="flex items-center justify-center">
      <p className="text-center text-2xl py-5">{t("noProductsFound")}</p>
    </div>
  );
}
